"use strict";
import cookie from "react-cookies";
export function setData(key, value, expire) {
  cookie.save(key, value, { expires: expire });
}
export function getData(key) {
  return cookie.load(key);
}
